import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import InputTextArea from 'modules/_shared/components/InputTextArea';
import MandatoryField from 'modules/_shared/components/MandatoryField';
import NotarySection from 'modules/_shared/components/NotarySection';
import UploadDocument from 'modules/documents/components/UploadDocument';

import { useReclassificationModal } from '../context/ReclassificationModalContext';

const ReclassificationScriptureView: FC = () => {
  const { t } = useTranslate();

  const MAX_DATE = '2100-01-01';
  const MAX_COMMENT_LENGTH = 500;

  const { data, actions } = useReclassificationModal();
  return (
    <>
      <div className="form-group">
        <label className="form-label" htmlFor="capital-decrease-date">
          {t('Date')} <MandatoryField />
        </label>
        <div className="form-control-wrap">
          <input
            id="capital-decrease-date"
            type="date"
            className="form-control form-control-lg"
            value={data.date}
            onChange={actions.handleChangeDate}
            required
            max={MAX_DATE}
            min={data.lastOperationDate}
          />
        </div>
      </div>

      <UploadDocument
        label="AddDocumentOptional"
        inputLabel={data.file?.name || t('DragDocumentToUpload')}
        file={data.file}
        setFile={actions.handleChangeFile}
      />

      <InputTextArea
        id="dividends-comments"
        label={t('CommentsLabel')}
        value={data.comments}
        onChange={actions.handleChangeComments}
        maxLength={MAX_COMMENT_LENGTH}
        noResize
      />

      <div className="row mb-4">
        <NotarySection
          notaryName={data.notaryName}
          onChangeName={actions.onChangeNotaryName}
          notaryProtocol={data.notaryProtocol}
          onChangeProtocol={actions.onChangeNotaryProtocol}
          notaryCity={data.notaryCity}
          onChangeCity={actions.onChangeNotaryCity}
          lgSize
        />
      </div>
    </>
  );
};

export default ReclassificationScriptureView;
